<p-dialog
  styleClass="!bg-bg-surface-default !border-line-default p-4"
  [modal]="true"
  [visible]="visible">
  <ng-template pTemplate="headless">
    <ng-lottie
      [options]="options"
      style="display: block; height: 60px"></ng-lottie>
  </ng-template>
</p-dialog>
